import { render, staticRenderFns } from "./mdc-list-divider.vue?vue&type=template&id=27758a44&"
import script from "./mdc-list-divider.vue?vue&type=script&lang=ts&"
export * from "./mdc-list-divider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports